import { render, staticRenderFns } from "./teamrp.vue?vue&type=template&id=f513437a&scoped=true&"
import script from "./teamrp.vue?vue&type=script&lang=js&"
export * from "./teamrp.vue?vue&type=script&lang=js&"
import style0 from "./teamrp.vue?vue&type=style&index=0&id=f513437a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f513437a",
  null
  
)

export default component.exports